import { Button, InlineBanner, Text } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { reactular } from '@vendhq/reactular'
import React, { useState } from 'react'
import { useAppSelector } from '../../../state/hooks'
import {
  selectIsSavedService,
  selectServiceAgendaBannerText,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { ServiceModal } from '../../react/modals/service-modal/ServiceModal'
import { STEPS } from '../../react/modals/service-modal/Steps/types'

interface Props {
  shouldShowServiceBanner: boolean
}

export const SaleServiceBanner: React.FC<Props> = ({
  shouldShowServiceBanner,
}) => {
  const t = useT()
  const [showModal, setShowModal] = useState(false)

  const openServiceModal = () => {
    setShowModal(true)
  }

  const isSavedService = useAppSelector(selectIsSavedService)
  const serviceAgendaBannerText = useAppSelector(selectServiceAgendaBannerText)

  return (
    <>
      {showModal && (
        <ServiceModal
          close={() => setShowModal(false)}
          isEditing={true}
          startWithStep={STEPS.CUSTOMER_ITEM}
        />
      )}
      {shouldShowServiceBanner && (
        <InlineBanner variant="info" icon="info-circle">
          <Text type="label">
            {t(serviceAgendaBannerText, { _context: 'Sale service banner' })}
            &nbsp;
            {!isSavedService && (
              <Button
                link
                className="vd-link vd-link--secondary"
                onClick={openServiceModal}
                data-testid="sale-service-banner-button"
              >
                {t('Edit service', { _context: 'Service agenda edit button' })}
              </Button>
            )}
          </Text>
        </InlineBanner>
      )}
    </>
  )
}

export const ReactSaleServiceBannerComponent = reactular(
  SaleServiceBanner,
  ['shouldShowServiceBanner'],
  'reactWrapper'
)
